import { Avatar, Box, styled, Typography } from '@mui/material';
import React from 'react';
import { getInitialsOfName } from '../../utils';

/**
 * AvatarWithText Component
 *
 * This component renders an avatar image alongside text content, with a heading and a subheading.
 * It displays the avatar on the left, followed by the heading and subheading text to the right,
 * arranged in a flex layout for alignment and spacing. Ideal for user profiles or list items
 * where an avatar and text need to be displayed together.
 *
 * @param {Object} props - Component props
 * @param {string} props.heading - Primary text or title to display next to the avatar.
 * @param {string} props.subHeading - Secondary text to display below the heading.
 * @param {string} [props.img='/images/logo/relay-logo.png'] - Image source for the avatar; defaults to a logo if not provided.
 * @param {Object} props.other - Additional props to be passed to the root Box component.
 *
 * @returns {JSX.Element} A styled Box component displaying an avatar with a heading and subheading.
 */

// export const Heading = styled(Typography)(({ theme }) => ({
//     fontSize: theme.typography.customFontSize.medium,
//     fontWeight: theme.typography.fontWeightMedium,
//     color: theme.palette.text.neutralSecondary,

// }));
export const SubHeading = styled(Typography)(({ theme }) => ({
    fontSize: theme.typography.customFontSize.small,
    fontWeight: theme.typography.fontWeightRegular,
    lineHeight: '150%',
    color: theme.palette.text.neutralSecondary,
}));

function AvatarWithText({ heading, subHeading, img = '', ...props }) {
    return (
        <Box display={'flex'} justifyContent={'flex-start'} alignItems={'center'} {...props}>
            <Avatar
                src={img}
                sx={(theme) => ({
                    width: '40px',
                    height: '40px',
                    marginRight: theme.typography.generic.medium,
                })}
            >
                {getInitialsOfName(heading || '')}
            </Avatar>
            <Box>
                <Typography component={'p'} variant="paraText2" color={'text.neutralSecondary'} className="heading">
                    {heading}
                </Typography>
                <Typography component={'p'} variant="paraText6" color={'text.secondary'} className="heading">
                    {subHeading}
                </Typography>
            </Box>
        </Box>
    );
}

export default AvatarWithText;
